import { render, staticRenderFns } from "./PGMPotentialApplicantsMap.vue?vue&type=template&id=45b6827e&"
import script from "./PGMPotentialApplicantsMap.vue?vue&type=script&lang=js&"
export * from "./PGMPotentialApplicantsMap.vue?vue&type=script&lang=js&"
import style0 from "./PGMPotentialApplicantsMap.vue?vue&type=style&index=0&id=45b6827e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports